import { ToastService } from "@shared/lib/services";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";

export function useGetAiWorkspaceRequests(aiWorkspaceId: string) {
  const { data, isLoading, isError, error, isFetching, refetch } = useQuery({
    queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS, aiWorkspaceId],
    queryFn: () => AiWorkspaceService.getAIWorkspaceRequests(aiWorkspaceId),
    enabled: !!aiWorkspaceId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    data,
    isFetching: isLoading || isFetching,
    isError,
    refetch,
  };
}
